import { useState, useEffect, useCallback } from 'react';
import {
    initInstallPrompt,
    canShowInstallPrompt,
    triggerInstallPrompt,
    isIOSDevice,
    isRunningAsStandalone,
    getInstallDismissed,
    setInstallDismissed
} from './installService';

function InstallBanner() {
    const [showBanner, setShowBanner] = useState(false);
    const [isIOS, setIsIOS] = useState(false);
    const [hasNativePrompt, setHasNativePrompt] = useState(false);
    const [installing, setInstalling] = useState(false);

    const evaluateVisibility = useCallback(() => {
        if (isRunningAsStandalone() || getInstallDismissed()) {
            return;
        }

        if (isIOSDevice()) {
            setIsIOS(true);
            setShowBanner(true);
            return;
        }

        if (canShowInstallPrompt()) {
            setHasNativePrompt(true);
            setShowBanner(true);
        }
    }, []);

    useEffect(() => {
        if (isRunningAsStandalone() || getInstallDismissed()) {
            return;
        }

        initInstallPrompt(() => {
            setHasNativePrompt(true);
            if (!getInstallDismissed()) {
                setShowBanner(true);
            }
        });

        evaluateVisibility();
    }, [evaluateVisibility]);

    const handleInstall = async () => {
        setInstalling(true);
        try {
            const outcome = await triggerInstallPrompt();
            if (outcome === 'accepted') {
                setShowBanner(false);
            }
        } finally {
            setInstalling(false);
        }
    };

    const handleDismiss = () => {
        setInstallDismissed();
        setShowBanner(false);
    };

    if (!showBanner) {
        return null;
    }

    return (
        <div className="install-banner-overlay">
            <div className="install-banner-modal">
                <div className="install-banner-header">
                    <h2>Instalar aplicativo</h2>
                    <p>
                        Instale o app <strong>Casa Viva</strong> para uma experiência
                        completa, com acesso rápido e notificações de novos episódios.
                    </p>
                </div>

                {isIOS ? (
                    <div className="install-banner-ios-steps">
                        <p className="install-banner-ios-title">
                            Para instalar no seu dispositivo:
                        </p>
                        <ol>
                            <li>
                                Toque no ícone de{' '}
                                <strong>Compartilhar</strong>{' '}
                                <span aria-hidden="true" style={{ fontSize: '1.2em' }}>⬆️</span>{' '}
                                na barra do navegador
                            </li>
                            <li>
                                Selecione{' '}
                                <strong>"Adicionar à Tela de Início"</strong>
                            </li>
                            <li>
                                Toque em <strong>"Adicionar"</strong>
                            </li>
                        </ol>
                    </div>
                ) : hasNativePrompt ? (
                    <button
                        className="install-banner-button install-banner-button-primary"
                        onClick={handleInstall}
                        disabled={installing}
                    >
                        {installing ? 'Instalando...' : 'Instalar agora'}
                    </button>
                ) : null}

                <button
                    className="install-banner-button install-banner-button-secondary"
                    onClick={handleDismiss}
                    disabled={installing}
                >
                    Agora não
                </button>
            </div>
        </div>
    );
}

export default InstallBanner;
